import {useAuthStore} from "~/store/auth"
import {defineNuxtPlugin, useCookie} from "#app"
import {AUTH_TOKEN_COOKIE_NAME, PRICE_TOKEN_COOKIE_NAME} from "~/utils/userUtils"
import {useConfigStore} from "~/store/config"
import {cookieOptions} from "~/utils/cookieUtils"

export default defineNuxtPlugin(async () => {
  const authStore = useAuthStore()
  const configStore = useConfigStore()

  const authCookie = useCookie(AUTH_TOKEN_COOKIE_NAME, cookieOptions)
  const priceTokenCookie = useCookie(PRICE_TOKEN_COOKIE_NAME, cookieOptions)

  if(priceTokenCookie.value) {
    authStore.setPriceToken(priceTokenCookie.value)
  }

  if (authCookie.value) {
    try {
      await authStore.login(authCookie.value)
    }catch (e) {
      console.error(e)
      if(e.message.includes('jwt_') || e.message.includes("not_enough_permissions")) {
        throw createError({ statusCode: 401, statusMessage: 'Invalid session' })
      }else if(e.message === 'customer_disabled'){
        throw createError({ statusCode: 401, statusMessage: 'Customer disabled' })
      }else{
        throw createError({ statusCode: 503, statusMessage: 'Server not available' })
      }
    }
  }

  await configStore.load()
})
